(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7785],{

/***/ 79989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ informativeStamps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/constants.ts
var stamps = {
    VEGAN: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FYNHhFnJ49oaeNo4bh-VEGAN.svg",
        label: "Vegano"
    },
    VEGETARIAN: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FTtMZJWqFeoM6jXZPT-VEGETARIAN.svg",
        label: "Vegetariano"
    },
    CACAO_100: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FvyL8X6C4BMa3GmGPB-COCOA_100.svg",
        label: "100% cacao"
    },
    GLUTEN_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FpAkb6dT9J5BCNdw9b-GLUTEN_FREE.svg",
        label: "Sin gluten"
    },
    LACTOSE_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FXN85u2RmNmZzZbXwm-LACTOSE_FREE.svg",
        label: "Sin lactosa"
    },
    SUGAR_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2F9tFGhk4Yeo7CGrb4p-SUGAR_FREE.svg",
        label: "Sin az\xfacar"
    },
    RECYCLABLE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FuytNnxyQ8HnKkJgqe-RECYCLABLE.svg",
        label: "Reciclable"
    },
    SPICY: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FRo6uAC2RWMGg3Tqa7-SPICY.svg",
        label: "Picante"
    },
    RECYCLED: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2Ft2xxZt5dqeK5JxWSx-RECICLED.svg",
        label: "Reciclado"
    },
    HANDMADE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FDCynECNEfDyMFAaed-HANDMADE.svg",
        label: "Hecho a mano"
    },
    OLDER_THAN_18: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FKKF3DBuShnTzrNrLz-OLDER_THAN_18.svg",
        label: "Mayor de 18"
    },
    CRUELTY_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FyNBMHBvXPe5gjraTt-CRUELTY_FREE.svg",
        label: "No testeado en animales"
    },
    KETO: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2Fv99t5FTchxQkpjgY3-KETO.svg",
        label: "Keto"
    }
};
/* harmony default export */ var constants = (stamps);

// EXTERNAL MODULE: ./src/components/InformativeStamps/styles.module.css
var styles_module = __webpack_require__(24731);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/InformativeStamps/index.tsx






function informativeStamps(param) {
    var stamps = param.stamps, iconOnly = param.iconOnly;
    if (!(stamps === null || stamps === void 0 ? void 0 : stamps.length)) return null;
    return stamps.map(function(stamp, index) {
        return iconOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
            content: constants[stamp].label,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).iconContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: constants[stamp].label,
                    src: constants[stamp].URL,
                    width: "16",
                    height: "16"
                }, index)
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).stampContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: constants[stamp].label,
                    src: constants[stamp].URL,
                    width: "16",
                    height: "16"
                }, index),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).label,
                    children: constants[stamp].label
                })
            ]
        });
    });
};


/***/ }),

/***/ 14726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trackPageView; }
/* harmony export */ });
/* harmony import */ var react_ga__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50542);
/* harmony import */ var ga_4_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13241);
/* harmony import */ var _helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55985);



function trackPageView(pathname) {
    var pixel = (0,_helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (!pathname.includes("/virtual")) {
        pixel === null || pixel === void 0 ? void 0 : pixel.pageView();
    }
    react_ga__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pageview */ .ZP.pageview(pathname);
    if (ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isInitialized */ .ZP.isInitialized()) {
        var ga4 = ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGA4React */ .ZP.getGA4React();
        if (ga4) {
            ga4.pageview(pathname);
        }
    }
};


/***/ }),

/***/ 55870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ECOMMERCE_EVENTS; },
  "Z": function() { return /* binding */ useTrackEcommerceEvent; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/i18n/getCurrencyCode.ts
var getCurrencyCode = __webpack_require__(2298);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var lib = __webpack_require__(25074);
// EXTERNAL MODULE: ./node_modules/uuid/index.js
var uuid = __webpack_require__(55877);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/sendEcommerceEventMutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation sendEcommerceEvent(\n    $eventName: String\n    $eventIdentifier: String\n    $actionSource: String\n    $orderId: ID\n    $currency: String\n    $items: [JSON]\n    $totalPrice: Float\n    $origin: String\n  ) {\n    sendEcommerceEvent(\n      eventName: $eventName\n      eventIdentifier: $eventIdentifier\n      actionSource: $actionSource\n      orderId: $orderId\n      currency: $currency\n      items: $items\n      totalPrice: $totalPrice\n      origin: $origin\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var sendEcommerceEventMutation = ((0,graphql_tag_lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./node_modules/react-ga/dist/esm/index.js + 12 modules
var esm = __webpack_require__(50542);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/helpers/getReactPixel.ts
var getReactPixel = __webpack_require__(55985);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/ga-4-react/dist/ga-4-react.esm.js
var ga_4_react_esm = __webpack_require__(13241);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/index.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var providers = {
    GA4: "ga4",
    PIXEL: "pixel",
    GTM: "gtm"
};
var pixelSendEvent = function(eventName, data, eventExtraData) {
    var reactPixel = (0,getReactPixel/* default */.Z)();
    reactPixel === null || reactPixel === void 0 ? void 0 : reactPixel.fbq("track", eventName, data, eventExtraData);
};
var recommendedEvents = {
    ADD_TO_CART: {
        pixel: "AddToCart",
        ga4: "add_to_cart",
        gtm: "add_to_cart"
    },
    BEGIN_CHECKOUT: {
        pixel: "InitiateCheckout",
        ga4: "begin_checkout",
        gtm: "begin_checkout"
    },
    PURCHASE: {
        pixel: "Purchase",
        ga4: "purchase",
        gtm: "purchase"
    },
    SELECT_ITEM: {
        ga4: "select_item",
        gtm: "select_item"
    }
};
var ga4SendEvent = function(action, additionalData) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, label = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, category = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, nonInteraction = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if ((0,isServerSide/* default */.Z)()) return;
    var isInitialized = ga_4_react_esm/* default.isInitialized */.ZP.isInitialized();
    if (!isInitialized) {
        return;
    }
    var ga4 = ga_4_react_esm/* default.getGA4React */.ZP.getGA4React();
    if (!ga4) {
        logger/* default.warn */.Z.warn("Could not get GA4React");
        return;
    }
    var data = _objectSpread({}, additionalData);
    if (custom) {
        data = _objectSpread({}, data, {
            event_label: label,
            event_category: category,
            nonInteraction: nonInteraction
        });
    }
    ga4.gtag("event", action, data);
};
var gtmSendEvent = function(dataLayer) {
    dist_default().dataLayer({
        dataLayer: dataLayer
    });
};
var analyticsEventManager = {
    pixel: pixelSendEvent,
    ga4: ga4SendEvent,
    gtm: gtmSendEvent
};

// EXTERNAL MODULE: ./src/helpers/track/trackPageView.ts
var trackPageView = __webpack_require__(14726);
;// CONCATENATED MODULE: ./src/helpers/track/trackAddToCart.ts




function trackAddToCart(param, param1) {
    var product = param.product, item = param.item, amount = param.amount, eventId = param1.eventId;
    if (!product || !item) return;
    var currency = (0,getCurrencyCode/* default */.Z)();
    esm/* default.set */.ZP.set({
        currencyCode: currency
    });
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "addProduct", {
        id: product._id,
        name: product.name,
        price: item.unitPrice,
        category: product.categories.length ? product.categories[0].internalName : null,
        quantity: amount,
        currency: currency
    });
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "setAction", "add");
    esm/* default.event */.ZP.event({
        category: "UX",
        action: "addProductToCart",
        label: "Agregar al carro"
    });
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id,
        value: item.unitPrice,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.ADD_TO_CART.pixel, pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: item.unitPrice,
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                price: item.unitPrice,
                quantity: amount
            }
        ]
    };
    analyticga4SendEvent(recommendedEvents.ADD_TO_CART.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.ADD_TO_CART.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name,
                    price: item.unitPrice,
                    quantity: amount
                }
            ]
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/add_to_cart");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackInitCheckout.ts



function trackInitCheckout(param, param1) {
    var cart = param.cart, eventId = param1.eventId;
    if (!cart) return;
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "setAction", "checkout");
    esm/* default.pageview */.ZP.pageview("/checkout");
    var currency = (0,getCurrencyCode/* default */.Z)();
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var numItems = cart.items.reduce(function(sum, item) {
        return item.amount + sum;
    }, 0);
    var pixelData = {
        value: cart.itemsPrice,
        num_items: numItems,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.BEGIN_CHECKOUT.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(cart.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: cart.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.BEGIN_CHECKOUT.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.BEGIN_CHECKOUT.gtm,
        ecommerce: {
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
};

;// CONCATENATED MODULE: ./src/helpers/track/trackProductView.ts
function trackProductView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function trackProductView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            trackProductView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function trackProductView(param, param1) {
    var product = param.product, eventId = param1.eventId;
    if (!product) return;
    if (!product.availabilityAt) return;
    var finalPrice = product.availabilityAt.finalPrice;
    var currencyCode = (0,getCurrencyCode/* default */.Z)();
    var gaData = {
        id: product._id,
        name: product.name,
        category: product.categories.length ? product.categories[0].internalName : null
    };
    var ga4Data = {
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                category: product.categories.length ? product.categories[0].internalName : null,
                currency: currencyCode
            }
        ]
    };
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id
    };
    var gtmData = {
        event: recommendedEvents.SELECT_ITEM.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name
                }
            ]
        }
    };
    if (finalPrice) {
        pixelData = trackProductView_objectSpread({}, pixelData, {
            value: finalPrice,
            currency: currencyCode
        });
        ga4Data["items"] = [
            trackProductView_objectSpread({}, ga4Data["items"][0], {
                price: finalPrice
            })
        ];
        gtmData["ecommerce"]["items"] = [
            trackProductView_objectSpread({}, gtmData["ecommerce"]["items"][0], {
                price: finalPrice
            })
        ];
        gaData = trackProductView_objectSpread({}, gaData, {
            price: finalPrice
        });
    }
    esm/* default.set */.ZP.set({
        currencyCode: currencyCode
    });
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "addImpression", gaData);
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "setAction", "detail");
    esm/* default.pageview */.ZP.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    analyticPixelSendEvent("ViewContent", pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    analyticga4SendEvent(recommendedEvents.SELECT_ITEM.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/view_content");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackPurchase.ts




function trackPurchase(param, param1) {
    var order = param.order, eventId = param1.eventId;
    if (!order) return;
    var currency = (0,getCurrencyCode/* default */.Z)();
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "clear", {});
    esm/* default.set */.ZP.set({
        currencyCode: currency
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = order.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            esm/* default.plugin.execute */.ZP.plugin.execute("ec", "addProduct", {
                id: item.product._id,
                name: item.product.name,
                category: item.product.categories.length ? item.product.categories[0].internalName : null,
                price: item.unitPrice,
                quantity: item.amount
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    esm/* default.plugin.execute */.ZP.plugin.execute("ec", "setAction", "purchase", {
        id: order._id,
        revenue: order.totalPrice,
        coupon: order.couponCode,
        shipping: order.deliveryFee
    });
    esm/* default.pageview */.ZP.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        value: order.totalPrice,
        num_items: order.totalItems,
        currency: currency,
        content_type: "product",
        content_ids: Array.from(order.items.map(function(item) {
            return item.product._id;
        }))
    };
    analyticPixelSendEvent(recommendedEvents.PURCHASE.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(order.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            item_category: item.product.categories.length ? item.product.categories[0].internalName : null,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        transaction_id: order._id,
        value: order.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.PURCHASE.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.PURCHASE.gtm,
        ecommerce: {
            currency: currency,
            transaction_id: order._id,
            value: order.totalPrice,
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/purchase");
};

;// CONCATENATED MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useTrackEcommerceEvent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useTrackEcommerceEvent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useTrackEcommerceEvent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var ECOMMERCE_EVENTS;
(function(ECOMMERCE_EVENTS) {
    ECOMMERCE_EVENTS["PAGEVIEW"] = "PageView";
    ECOMMERCE_EVENTS["VIEWCONTENT"] = "ViewContent";
    ECOMMERCE_EVENTS["INITCHECKOUT"] = "InitiateCheckout";
    ECOMMERCE_EVENTS["ADDTOCART"] = "AddToCart";
    ECOMMERCE_EVENTS["PURCHASE"] = "Purchase";
})(ECOMMERCE_EVENTS || (ECOMMERCE_EVENTS = {}));
function serverSendEvent(eventName, mutate, data) {
    return _serverSendEvent.apply(this, arguments);
}
function _serverSendEvent() {
    _serverSendEvent = _asyncToGenerator(runtime_default().mark(function _callee(eventName, mutate, data) {
        var orderId, eventId, source, items, currency, totalPrice, variables;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (mutate) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    orderId = data.orderId, eventId = data.eventId, source = data.source, items = data.items, currency = data.currency, totalPrice = data.totalPrice;
                    variables = useTrackEcommerceEvent_objectSpread({
                        eventName: eventName,
                        eventIdentifier: eventId,
                        currency: currency,
                        totalPrice: totalPrice,
                        actionSource: source,
                        origin: "web"
                    }, items && {
                        items: items
                    }, orderId && {
                        orderId: orderId
                    });
                    _ctx.next = 7;
                    return mutate({
                        mutation: sendEcommerceEventMutation,
                        variables: variables
                    });
                case 7:
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    logger/* default.warn */.Z.warn("could not send event to ecommerceEvents", {
                        error: _ctx.t0
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _serverSendEvent.apply(this, arguments);
}
function useTrackEcommerceEvent() {
    var mutate = (0,lib.useMutate)();
    var trackEcommerceEvent = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event1, params1) {
            var getEventServerData, serverData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getEventServerData = function _getEventServerData(event, params) {
                            var eventId = (0,uuid.v4)();
                            var currency = (0,getCurrencyCode/* default */.Z)();
                            var baseData = {
                                currency: currency,
                                eventId: eventId,
                                source: location.origin
                            };
                            if (event === ECOMMERCE_EVENTS.PAGEVIEW) {
                                (0,trackPageView/* default */.Z)(params);
                                return null;
                            }
                            if (event === ECOMMERCE_EVENTS.VIEWCONTENT) {
                                trackProductView(params, {
                                    eventId: eventId
                                });
                                var product = params.product;
                                var items = [
                                    {
                                        id: product._id,
                                        quantity: 1,
                                        itemPrice: product.value,
                                        itemName: product.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items,
                                    totalPrice: product.value
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.INITCHECKOUT) {
                                trackInitCheckout(params, {
                                    eventId: eventId
                                });
                                var cart = params.cart;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: Array.from(cart.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    })),
                                    totalPrice: cart.itemsPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.ADDTOCART) {
                                trackAddToCart(params, {
                                    eventId: eventId
                                });
                                var product1 = params.product, amount = params.amount, item1 = params.item;
                                var items1 = [
                                    {
                                        id: product1._id,
                                        quantity: amount,
                                        itemPrice: item1.unitPrice,
                                        itemName: product1.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items1,
                                    totalPrice: item1.totalPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.PURCHASE) {
                                trackPurchase(params, {
                                    eventId: eventId
                                });
                                var order = params.order;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    orderId: order._id,
                                    totalPrice: order.totalPrice
                                }, order.items && {
                                    items: Array.from(order.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    }))
                                });
                            }
                            return null;
                        };
                        _ctx.prev = 1;
                        ;
                        serverData = getEventServerData(event1, params1);
                        if (serverData) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return serverSendEvent(event1, mutate, serverData);
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        logger/* default.warn */.Z.warn("error useTrackEcommerceEvent", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function trackEcommerceEvent(event1, params1) {
            return _ref.apply(this, arguments);
        };
    }();
    return trackEcommerceEvent;
};


/***/ }),

/***/ 18085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormatNumber; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78263);




/**
 * Formats the number as a currency using the locale of the current website obtained through the initialData context.
 */ function FormatNumber(param) {
    var value = param.value, _format = param.format, format = _format === void 0 ? "money" : _format, localeParam = param.locale, render = param.render, _removeSymbolPreffix = param.removeSymbolPreffix, removeSymbolPreffix = _removeSymbolPreffix === void 0 ? false : _removeSymbolPreffix;
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var locale = localeParam !== null && localeParam !== void 0 ? localeParam : initialData.website.country.locale;
    var number = (0,_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value, format, locale, removeSymbolPreffix);
    if (render) {
        return render(number);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: number
    });
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GetCurrencyCode; }
/* harmony export */ });
/* harmony import */ var _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66767);

function GetCurrencyCode() {
    var locale = __webpack_require__.g.currentLocale || "es_CL";
    return _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[locale];
};


/***/ }),

/***/ 58861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFilteredModifiers; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function getFilteredModifiers(modifiers) {
    var findOption = function(option) {
        return option.availabilityAt && option.availabilityAt.available;
    };
    var findModifier = function(modifier) {
        return modifier.options && !!modifier.options.find(findOption);
    };
    return modifiers.map(function(modifier, index) {
        return _objectSpread({}, modifier, {
            index: index
        });
    }).filter(findModifier);
};


/***/ }),

/***/ 8184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getResume; }
});

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getPricePerItem.ts
function getPricePerItem(product, state) {
    var includeDiscount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!(product === null || product === void 0 ? void 0 : product.availabilityAt)) return;
    var price = includeDiscount ? product.availabilityAt.finalPrice : product.availabilityAt.basePrice;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop1 = function(_iterator, _step) {
            var _value = _step.value, modifierId = _value.modifierId, optionsIds = _value.optionsIds;
            var modifier1 = product.modifiers.find(function(modifier) {
                return modifier._id === modifierId;
            });
            if (!modifier1) return "continue";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function(_iterator1, _step1) {
                    var optionId = _step1.value;
                    var option1 = modifier1.options.find(function(option) {
                        return option._id === optionId;
                    });
                    if (!option1) return "continue";
                    if (!option1.availabilityAt) return "continue";
                    if (!option1.availabilityAt.price) return "continue";
                    price += option1.availabilityAt.price;
                };
                for(var _iterator1 = optionsIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true)_loop(_iterator1, _step1);
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        for(var _iterator = state.modifiers[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true)_loop1(_iterator, _step);
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return price;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getFilteredModifiers.ts
var getFilteredModifiers = __webpack_require__(58861);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getRemainingOptionsCount.ts
function getRemainingOptionsCount(modifier, count) {
    var min = modifier.min, optional = modifier.optional;
    if (optional && count === 0) return 0;
    var remainingOptions = min - count;
    return remainingOptions < 0 ? 0 : remainingOptions;
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getMissingModifier.ts
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};


function getMissingModifiers(product, state) {
    var modifiers = (product === null || product === void 0 ? void 0 : product.modifiers) || [];
    if (!modifiers.length) return;
    var filteredModifiers = (0,getFilteredModifiers/* default */.Z)(modifiers);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function(_iterator, _step) {
            var modifier = _step.value;
            if (modifier.optional && !modifier.min) return "continue";
            var stateModifier = state.modifiers.find(function(item) {
                return item.modifierId === modifier._id;
            });
            if (modifier.min) {
                var remainingOptions = getRemainingOptionsCount(modifier, stateModifier.optionsIds.length);
                if (remainingOptions > 0) {
                    return {
                        v: modifier
                    };
                } else {
                    return "continue";
                }
            }
            if (!stateModifier.optionsIds.length) {
                return {
                    v: modifier
                };
            }
        };
        for(var _iterator = filteredModifiers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop(_iterator, _step);
            if (_typeof(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getResume.ts


function getResume(props, state, product) {
    var missingModifier = getMissingModifiers(product, state);
    var amount = state.amount;
    var unitPrice = getPricePerItem(product, state, true);
    var baseUnitPrice = getPricePerItem(product, state, false);
    return {
        ready: !missingModifier,
        missingModifier: missingModifier,
        price: amount * unitPrice,
        basePrice: amount * baseUnitPrice,
        amount: amount,
        unitPrice: unitPrice,
        baseUnitPrice: baseUnitPrice
    };
};


/***/ }),

/***/ 16337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAdd; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var lib = __webpack_require__(25074);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/mutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation addProductToCart(\n    $productId: ID\n    $amount: Float\n    $modifiers: [CartItemOptionInput]\n    $comment: String\n    $menuId: ID\n  ) {\n    item: addProductToCart(\n      productId: $productId\n      amount: $amount\n      modifiers: $modifiers\n      comment: $comment\n      menuId: $menuId\n    ) {\n      _id\n      totalPrice(includeDiscount: true)\n      unitPrice\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutation = ((0,graphql_tag_lib["default"])(_templateObject()));

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/mutationEdit.ts
function mutationEdit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mutationEdit_templateObject() {
    var data = mutationEdit_taggedTemplateLiteral([
        "\n  mutation updateCartItem(\n    $productId: ID\n    $amount: Float\n    $modifiers: [CartItemOptionInput]\n    $comment: String\n    $menuId: ID\n    $cartItemId: ID\n  ) {\n    item: updateCartItem(\n      cartItemId: $cartItemId\n      productId: $productId\n      amount: $amount\n      modifiers: $modifiers\n      comment: $comment\n      menuId: $menuId\n    ) {\n      _id\n      totalPrice(includeDiscount: true)\n      unitPrice\n    }\n  }\n"
    ]);
    mutationEdit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutationEdit = ((0,graphql_tag_lib["default"])(mutationEdit_templateObject()));

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/fragment.ts
function fragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function fragment_templateObject() {
    var data = fragment_taggedTemplateLiteral([
        "\n  fragment optimisticCartFragment on Cart {\n    items {\n      _id\n      isOutOfStock\n      outOfStockMessage\n      amount\n      realPrice: unitPrice(includeDiscount: false)\n      unitPrice\n      description\n      descriptionItems {\n        title\n        selections\n      }\n      product {\n        _id\n        name\n      }\n    }\n    storeId\n    deliveryType\n    deliveryFee\n    menuId\n    itemsPrice\n    realPrice: itemsPrice(includeDiscount: false)\n    totalPrice\n    amountToPay\n  }\n"
    ]);
    fragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var fragment = ((0,graphql_tag_lib["default"])(fragment_templateObject()));

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getResume.ts + 3 modules
var getResume = __webpack_require__(8184);
// EXTERNAL MODULE: ./src/helpers/misc/generateId.ts
var generateId = __webpack_require__(6882);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/optimisticUpdateCart.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function optimisticUpdateCart(param) {
    var client = param.client, props = param.props, state = param.state, product = param.product;
    try {
        var ref = (0,getResume/* default */.Z)(props, state, product), price = ref.price, basePrice = ref.basePrice, amount = ref.amount, unitPrice = ref.unitPrice, baseUnitPrice = ref.baseUnitPrice;
        var data = client.readFragment({
            id: "cart",
            fragment: fragment
        });
        client.writeFragment({
            id: "cart",
            fragment: fragment,
            data: _objectSpread({}, data, {
                items: _toConsumableArray(data.items).concat([
                    {
                        _id: "pending:".concat((0,generateId/* default */.Z)()),
                        isOutOfStock: false,
                        outOfStockMessage: null,
                        amount: amount,
                        realPrice: baseUnitPrice,
                        unitPrice: unitPrice,
                        description: "",
                        descriptionItems: [],
                        product: {
                            _id: product._id,
                            name: product.name,
                            __typename: "Product"
                        },
                        __typename: "CartItem"
                    }
                ]),
                itemsPrice: data.itemsPrice + price,
                realPrice: data.realPrice + basePrice,
                totalPrice: data.totalPrice + price,
                amountToPay: data.amountToPay + price
            })
        });
    } catch (error) {
        console.log("Error:", error);
    }
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useAdd_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useAdd_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useAdd_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function useAdd() {
    var mutate = (0,lib.useMutate)();
    var showMessage = (0,useMessage/* default */.Z)();
    var client = (0,lib.useClient)();
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    // TODO (Important): Refactor and set types
    return function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(props, state, product, resume) {
            var opts, setLoading, keepLoadingOnFinish, success, variables, item, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        opts = _args.length > 4 && _args[4] !== void 0 ? _args[4] : {};
                        setLoading = opts.setLoading, keepLoadingOnFinish = opts.keepLoadingOnFinish;
                        success = false;
                        if (!resume.missingModifier) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,fireEvent["default"])("scrollToRequiredModifier", resume.missingModifier);
                        return _ctx.abrupt("return");
                    case 6:
                        if (setLoading) setLoading(true);
                        _ctx.prev = 7;
                        variables = {
                            productId: props.product._id,
                            amount: state.amount,
                            modifiers: state.modifiers,
                            comment: state.comment,
                            menuId: props.menuId
                        };
                        if (!props.cartItem) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 12;
                        return mutate({
                            mutation: mutationEdit,
                            variables: useAdd_objectSpread({
                                cartItemId: props.cartItem._id
                            }, variables),
                            refetchQueries: [
                                "getMyCart",
                                "getMyOrderPreferences"
                            ]
                        });
                    case 12:
                        _ctx.next = 21;
                        break;
                    case 14:
                        optimisticUpdateCart({
                            client: client,
                            props: props,
                            state: state,
                            product: product
                        });
                        _ctx.next = 17;
                        return mutate({
                            mutation: mutation,
                            variables: variables,
                            refetchQueries: [
                                "getMyCart",
                                "getMyOrderPreferences"
                            ]
                        });
                    case 17:
                        item = _ctx.sent.item;
                        _ctx.next = 20;
                        return trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.ADDTOCART */.X.ADDTOCART, {
                            product: product,
                            item: item,
                            amount: state.amount
                        });
                    case 20:
                        (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.productAddToCart, {
                            amount: state.amount
                        });
                    case 21:
                        if (props.onAdd) {
                            props.onAdd();
                        }
                        props.close();
                        success = true;
                        _ctx.next = 29;
                        break;
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](7);
                        showMessage(_ctx.t0);
                    case 29:
                        // In some cases, we want to keep showing the loading state until the location changes
                        if (setLoading && !keepLoadingOnFinish && !success) setLoading(false);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    26
                ]
            ]);
        }));
        return function(props, state, product, resume) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 68632:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var promotionType = {
    buyOneGiveOne: function(t) {
        return t("promotionType.buyOneGiveOne");
    },
    delivery: function(t) {
        return t("promotionType.delivery");
    },
    rateDiscount: function(t) {
        return t("promotionType.rateDiscount");
    },
    amountDiscount: function(t) {
        return t("promotionType.amountDiscount");
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (promotionType);


/***/ }),

/***/ 24731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_1FBOTCTDk1tpvN0CWtJEGO","stampContainer":"_2dHjoWB7y4fjNlK-GGZIHV","informativeStampsContainer":"TLYGzXDnclJIHO_eFXkgD","label":"_3tC3I5ZkO3-9aTewxfaeGV"};

/***/ })

}]);